import React, { useEffect, useState, useRef } from "react";
import DatePicker from "react-date-picker";
import TimePicker from 'react-time-picker';
import "./V730iEventHistory.scss";
import { connect } from "react-redux";
import { ALARM_TYPE_FILTER } from "../../../common/constant/common-constants";
import blackDownArrow from "../../../common/icons/svg/black-down-arrow.svg";
import blackUpArrow from "../../../common/icons/svg/black-up-arrow.svg";
import whiteUpArrow from "../../../common/icons/svg/white-up-arrow.svg";
import whiteDownArrow from "../../../common/icons/svg/white-down-arrow.svg";
import priority_high_svg from "../../../common/icons/svg/priority-high.svg";
import priority_medium_svg from "../../../common/icons/svg/priority-medium.svg";
import priority_low_svg from "../../../common/icons/svg/priority-low.svg";
import moment from "moment";
import V730iParameterGraph from "./V730iParameterGraph";
import arrow from "../../../common/images/Vector.png";
import { getV730iPatientHistoryEventHistoryData } from "../../../helper/patient-history-helper";
import V730iSetParameterHistory from "./V730iSetParameterHistory";
import lung_svg from "../../../common/icons/svg/lungs.svg";
import consolidation_svg from "../../../common/icons/svg/consolidation.svg"
import { ventilatorPatientHistoryEventHistoryData } from "../../../modules/actions/action";


const BATCH_SIZE = 50;
function V730iEventHistory(props) {

    const [isOpen, setIsOpen] = useState(false);
    const [selectedTab, setSelectedTab] = useState('history');
    const [eventFilter, setEventFilter] = useState(ALARM_TYPE_FILTER?.[0].name);
    const dropdownRef = useRef(null);
    const [eventHistoryData, setEventHistoryData] = useState([])
    const [offset, setOffset] = useState(null)
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);

    const loadEventHistory = async (isReset = false) => {
        if (loading) return;

        setLoading(true);
        const startingPoint = isReset ? 0 : offset;
        // console.log("startingPoint in loadEventHistory---->", startingPoint)
        // console.log("eventFilter", eventFilter)
        //Check in cache 
        //Check the PatientHistoryTimeData has data or not

        try {
            if (props?.PatientHistoryTimeData && Object.keys(props?.PatientHistoryTimeData).length > 0) {
                //Check whether PatientHistoryGraphData has data or not 
                if (props?.PatientHistoryEventHistoryData && Object.keys(props?.PatientHistoryEventHistoryData).length > 0 && !(props.PatientHistoryEventHistoryData?.isLoading)) {
                    // console.log("PatientHistoryEventHistoryData avaliable in cache")
                    if (props.PatientHistoryEventHistoryData?.eventHistoryData[eventFilter] && props.PatientHistoryEventHistoryData?.eventHistoryData[eventFilter].length > 0) {
                        // console.log("PatientHistoryEventHistoryData of desired eventfilter avaliable in cache")
                        let cacheEventHistoryData = props.PatientHistoryEventHistoryData.eventHistoryData[eventFilter]

                        let offsetRangeData = cacheEventHistoryData.slice(startingPoint, startingPoint + BATCH_SIZE) || []

                        if (offsetRangeData.length === BATCH_SIZE) {
                            // console.log("Found desired offset range data in cache for the eventfilter , no need to call api")

                            setEventHistoryData((prevData) => {
                                setOffset(prevData.length + offsetRangeData.length);
                                return [...prevData, ...offsetRangeData]
                            });

                        }
                        else {
                            try {
                                // console.log("Not found desired offrange range data in cache for the eventfilter .....calling api")

                                props.ventilatorPatientHistoryEventHistoryData({
                                    bedId: props.bedId,
                                    isLoading: true,
                                    eventHistoryData: props.PatientHistoryEventHistoryData.eventHistoryData
                                })

                                const apiObj = {
                                    bedId: props.bedId,
                                    startDateTime: props.PatientHistoryTimeData?.startDateTime,
                                    endDateTime: props.PatientHistoryTimeData?.endDateTime,
                                    typeFilter: eventFilter,
                                    offset: startingPoint + offsetRangeData.length,
                                    limit: BATCH_SIZE
                                };

                                const res = await getV730iPatientHistoryEventHistoryData(apiObj);

                                setEventHistoryData((prevData) => {
                                    setOffset(prevData.length + offsetRangeData.length + res.data.length);
                                    return [...prevData, ...offsetRangeData, ...res.data]

                                });

                                props.ventilatorPatientHistoryEventHistoryData({
                                    bedId: props.bedId,
                                    isLoading: false,
                                    eventHistoryData: {
                                        ...props.PatientHistoryEventHistoryData.eventHistoryData,
                                        [eventFilter]: [...cacheEventHistoryData, ...res.data]
                                    }

                                }) //Dispatch isLoading false + new-Data

                                if (res.data.length < BATCH_SIZE) setHasMore(false);
                            } catch (err) {
                                console.log("Error in getV730iPatientHistoryEventHistoryData api :", err);
                            }
                        }
                    } else {
                        try {
                            // console.log("PatientHistoryEventHistoryData of desired eventfilter is not avaliable in cache...calling api")

                            props.ventilatorPatientHistoryEventHistoryData({
                                bedId: props.bedId,
                                isLoading: true,
                                eventHistoryData: props.PatientHistoryEventHistoryData.eventHistoryData
                            })

                            const apiObj = {
                                bedId: props.bedId,
                                startDateTime: props.PatientHistoryTimeData?.startDateTime,
                                endDateTime: props.PatientHistoryTimeData?.endDateTime,
                                typeFilter: eventFilter,
                                offset: startingPoint,
                                limit: BATCH_SIZE
                            };

                            const res = await getV730iPatientHistoryEventHistoryData(apiObj);

                            setEventHistoryData((prevData) => {
                                setOffset(prevData.length + res.data.length);
                                return [...prevData, ...res.data]

                            });

                            props.ventilatorPatientHistoryEventHistoryData({
                                bedId: props.bedId,
                                isLoading: false,
                                eventHistoryData: {
                                    ...props.PatientHistoryEventHistoryData.eventHistoryData,
                                    [eventFilter]: [...res.data]
                                }
                            });//Dispatch isLoading false + new-Data

                            if (res.data.length < BATCH_SIZE) setHasMore(false);

                        } catch (err) {
                            console.log("Error in getV730iPatientHistoryEventHistoryData api :", err);
                        }
                    }
                } else {
                    try {
                        // console.log("PatientHistoryEventHistoryData not avaliable in cache,.....Calling getV730iPatientHistoryEventHistoryData")

                        props.ventilatorPatientHistoryEventHistoryData({
                            bedId: props.bedId,
                            isLoading: true,
                            eventHistoryData: {}
                        })

                        const apiObj = {
                            bedId: props.bedId,
                            startDateTime: props.PatientHistoryTimeData?.startDateTime,
                            endDateTime: props.PatientHistoryTimeData?.endDateTime,
                            typeFilter: eventFilter,
                            offset: startingPoint,
                            limit: BATCH_SIZE
                        };

                        const res = await getV730iPatientHistoryEventHistoryData(apiObj);

                        setEventHistoryData((prevData) => {
                            setOffset(prevData.length + res.data.length);
                            return [...prevData, ...res.data]

                        });

                        props.ventilatorPatientHistoryEventHistoryData({
                            bedId: props.bedId,
                            isLoading: false,
                            eventHistoryData: {
                                [eventFilter]: [...res.data]
                            }
                        });//Dispatch isLoading false + new-Data

                        if (res.data.length < BATCH_SIZE) setHasMore(false);

                    } catch (err) {
                        console.log("Error in getV730iPatientHistoryEventHistoryData api :", err);
                    }
                }
            }
            else {
                console.log("PatientHistoryTimeData not avaliable in loadEventHistory")
            }
        }
        finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!eventFilter || !props.PatientHistoryTimeData || !(Object.keys(props.PatientHistoryTimeData).length > 0)) return;

        setEventHistoryData([]);
        setOffset(0);
        setHasMore(true);
        // RESET SCROLL POSITION ⇦ THIS IS THE FIX
        const container = document.querySelector(".event-history");
        if (container) {
            // console.log("reseting scroll position--0")
            container.scrollTop = 0;
        }

        // console.log("hit loadEventHistory from main useffect")
        loadEventHistory(true);
    }, [eventFilter, props.PatientHistoryTimeData]);

    // Intersection Observer for infinite scroll
    const scrollLockRef = useRef(false);

    useEffect(() => {
        const container = document.querySelector(".event-history");
        if (!container) return;

        const handleScroll = () => {

            if (scrollLockRef.current) return;
            const { scrollTop, clientHeight, scrollHeight } = container;

            const isNearBottom = scrollHeight - scrollTop - clientHeight < 150;
            // 150px buffer before bottom

            if (isNearBottom && hasMore && !loading) {
                // console.log("hit loadEventHistory from scroll");
                // loadEventHistory();
                scrollLockRef.current = true;   // lock immediately

                loadEventHistory().finally(() => {
                    scrollLockRef.current = false;  // unlock after API finishes
                });
            }
        };

        container.addEventListener("scroll", handleScroll);
        // Cleanup on unmount OR when dependencies change
        return () => {
            // console.log("loadEventHistory ::: scroll reset due to dependency change");
            container.removeEventListener("scroll", handleScroll);
        };

    }, [hasMore, loading, props.PatientHistoryTimeData, props.PatientHistoryEventHistoryData, eventFilter, offset]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);

        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const getPriority = (priority) => {
        let pr = priority?.toUpperCase();
        switch (pr) {
            case "HIGH":
                return { icon: priority_high_svg, color: '#AD0606', textColor: '#fff' };
            case "MEDIUM":
                return { icon: priority_medium_svg, color: '#FCC331', textColor: '#000' };
            case "LOW":
                return { icon: priority_low_svg, color: '#3ADAE5', textColor: '#000' };
            default:
                return { icon: '', color: '#3ADAE5' };
        }
    }



    // console.log("eventHistoryData----->", eventHistoryData)
    // console.log("eventFilter", eventFilter)
    const formatObservedTime = (utcTime) => {
        const date = new Date(utcTime);

        const day = date.toLocaleString("en-IN", { day: "2-digit", timeZone: "Asia/Kolkata" });
        const month = date.toLocaleString("en-IN", { month: "numeric", timeZone: "Asia/Kolkata" });
        const year = date.toLocaleString("en-IN", { year: "numeric", timeZone: "Asia/Kolkata" });

        const time = date.toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false
        });

        return {
            date: `${parseInt(day, 10)}/${parseInt(month, 10)}/${year}`,
            time
        };
    };


    return (
        <div className="event-history-container-right">
            <div className="event-history-header">
                <div className="event-history-header-title">Event History</div>
                <div className="event-filter">
                <div className="event-filter-input" ref={dropdownRef}>
                    <div className="dropdown-container">
                        <div
                            className="dropdown-trigger"
                            onClick={() => setIsOpen(!isOpen)}
                        >
                            <span className="dropdown-trigger-label">
                                {ALARM_TYPE_FILTER.find(
                                    (option) => option.name === eventFilter
                                )?.label}
                            </span>
                            <img
                                className="dropdown-arrow"
                                src={isOpen ? whiteUpArrow : whiteDownArrow}
                                alt=""
                            />
                        </div>
                        {isOpen && (
                            <div className="dropdown-menu">
                                {ALARM_TYPE_FILTER.filter(option => option.id !== 2).map((option) => (
                                    <div
                                        key={option.name}
                                        className={`dropdown-item ${eventFilter === option.name ? "selected" : ""
                                            }`}
                                        onClick={() => {
                                            setEventFilter(option.name);
                                            setIsOpen(false);
                                        }}
                                    >
                                        {option.label}
                                    </div>
                                ))}
                            </div>
                        )}

                    </div>
                </div>
                </div>
            </div>

            
            <div className="event-history">
                {eventHistoryData.map((item, index) => {
                    const formatted = formatObservedTime(item.observedTime);
                    return (
                        <div key={index} className="event-alarm">
                            <div className="event-alarm-date-time-container">
                                <div className="event-alarm-date">
                                    {formatted.date}
                                </div>
                                <div className="event-alarm-time">
                                    {formatted.time}
                                </div>
                            </div>

                            <div className="event-alarm-content-container">
                                <div className="event-alarm-content-priority">
                                    {(item.type === "PHYSIOLOGICAL" || item.type === "TECHNICAL") &&
                                        getPriority(item.priority).icon && (
                                            <img
                                                alt="priority icon"
                                                src={getPriority(item.priority).icon}
                                                className="priority"
                                            />
                                        )
                                    }
                                    {(item.type === "OPERATIONAL") &&
                                        <img
                                            alt="priority icon"
                                            src={item?.category === "additional_feature" ? lung_svg : consolidation_svg}
                                            className="priority"
                                        />
                                    }
                                </div>

                                <div className="event-alarm-content-message">
                                    {item.message}
                                </div>
                            </div>
                        </div>
                    );
                })}
                {loading && (
                    <div className="spinner-container">
                        <div className="spinner"></div>
                    </div>
                )}
            </div>
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {
    let ventilatorPatientHistoryTimeData = state.volatileDataReducer?.ventilatorPatientHistoryTimeData?.[ownProps.bedId]
    // console.log("ventilatorPatientHistoryTimeData in mapProps in V730iEventHistory", ventilatorPatientHistoryTimeData)

    let ventilatorPatientHistoryEventHistoryData = state.volatileDataReducer?.ventilatorPatientHistoryEventHistoryData?.[ownProps.bedId]
    // console.log("ventilatorPatientHistoryEventHistoryData in mapProps in V730iEventHistory", ventilatorPatientHistoryEventHistoryData)
    return {

        PatientHistoryTimeData: ventilatorPatientHistoryTimeData,
        PatientHistoryEventHistoryData: ventilatorPatientHistoryEventHistoryData

    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        ventilatorPatientHistoryEventHistoryData: (payload) => dispatch(ventilatorPatientHistoryEventHistoryData(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(V730iEventHistory);